import React from "react";
import Preloader from "../helper/Preloader";
import HeaderThree from "../components/HeaderThree";
import Breadcrumb from "../components/Breadcrumb";
import Footer from "../components/Footer";
import MyOrders from "../components/MyOrders";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
import NewsletterTwo from "../components/NewsletterTwo";


const MyOrdersPage = () => {
  return (
    <>
      <ColorInit color={true} />
      <ScrollToTop smooth color="var(--brand-primary)" />
      <Preloader />
      <HeaderThree />
      <Breadcrumb title={"My Orders"} />
      
      <MyOrders />
      
      {/* NewsletterTwo */}
      <NewsletterTwo />

      <Footer />
    </>
  );
};

export default MyOrdersPage;